// @ts-nocheck
export default {
    navbar: {
        login: '申请体验',
        text: '易特达科技',
        offerings: '产品服务',
        case: '客户案例',
        home: '首页',
        supervision: '数据监管',
        about: '关于我们',
        projectName: '易货贸易管理服务平台',
        tobacco: '马拉维、坦桑尼亚农产品',
        grapefruit: '南非西柚',
        rubber: '科特迪瓦腰果、橡胶',
        newDetail: '资讯详情',
    },
    common: {
        back: '返回',
        adds: '地区',
        noData: '暂无数据',
    },
    carousel: {
        title: '易特达科技-海豚软件系列',
        desc: '致力于为客户提供创新、高效的软件解决方案'
    },
    carousel1: {
        title: '易货服务;助力中非'
    },
    carousel2: {
        title: '中非资讯;精彩纷呈'
    },
    carousel3: {
        title: '易货交易;联系我们'
    },
    introduce: {
        title: '平台介绍',
        rightTitle: '新型易货贸易交易平台',
        infoText: '平台由一个统一的线上交易系统，境内外双边两家易货贸易公司组成，系统具备商机发布全球化、业务管理智慧化、合规监管实时化、综合服务一体化等功能特点，为各国生产商、终端消费户、贸易商各类贸易活动主体提供一站式贸易综合服务，实现货物跨国循环、资金各国境内独立循环的新型易货贸易，有效解决贸易活动中面临的外汇储备不足、汇率波动大、供需不够实时透明的业务难点。',
        textList: '标准易货运营模式,中国出口商A,人民币,平台境内共管账户,人民币,中国进口商C,委托代理出口商品1,信息管控,委托代理进口商品2,中国易货贸易公司,新型易货贸易交易平台,目标国易货贸易公司,委托代理进口商品1,信息管控,委托代理出口商品2,目标国进口商B,当地货币,平台境外共管账户,当地货币,目标国出口商D,海关、税务、外管、物流实时监管',
        cust: {
            title: '认证中国境内易货平台',
            value: '长沙国贸集团有限公司',
        },
        telSell: '(境外企业从中国采购-人民币卖出)',
        telBuy: '(境外企业供应给中国-人民币买入)',
    },
    columns: {
        '01': '商品名称',
        '02': '采购量',
        '03': '需求地区',
        '04': '易货价格',
        '05': '市场价格',
        '06': '易货币别',
        '07': '浮动',
        '08': '发布日期',
        '09': '操作',
        '10': '供应量',
        '11': '供应地区',
        '12': '货币国',
        '13': '本币币种',
        '14': '易货资金额(万)',
        '15': '美元汇率',
        '16': '非政策美元汇率',
        '17': '更新日期',
        '18': '详情',
        '19': '更多',
        '20': '国家',
        '21': '币别',
        '22': '单价',
        '23': '商品大类',
        '24': '规格型号',
        '25': '单位',
        '26': '总价',
        '27': '我要供应',
        '28': '供应信息',
        '29': '供应金额',
        '30': '易货汇率',
        '31': '商品信息',
        '32': '我要采购',
        '33': '采购信息',
        '34': '采购金额',
        '35': '我要发布',
        '36': '市场价格',
    },
    interest: {
        title: '资金信息',
        title1: '资金信息详情',
        title2: '随意发布',
    },
    purchase: {
        title: '热门采购',
        title2: '品类繁多',
        title1: '热门采购详情',
    },
    supplies: {
        title: '热门供应',
        title2: '物美价廉',
        title1: '热门供应详情',
    },
    case: {
        title: '易货资讯',
        title1: '精彩纷呈',
        tab1: '新闻资讯',
        tab2: '政策法规',
        year: '年份',
        month: '月份',
        form: '来源',
        date: '发布日期',
        font: '字体',
        prev: '上一条：',
        next: '下一条：',
        noBody: '无',
        big: '大',
        Medium: '中',
        small: '小',
        zengce: '政策详情'
    },
    interlinkage: {
        title: '友情链接',
        national: '商务部',
        national1: '海关总署',
        national2: '外汇管理局',
        national3: '湖南省中非经贸合作研究会',
        national4: '国家税务总局',
        national5: '中国（湖南）自由贸易试验区'
    },
    footerInfo: {
        address: '地址：长沙市岳麓区先导路179号湘江时代广场6楼',
        phone: '电话：+86 731 8822 2686',
        email: '邮箱：',
        trade: '中非易货贸易;抖音官方账号',
        trade1: '新型易货贸易交易;平台微信官方账号',
        trade2: '中非易货贸易;微博官方账号',
        custName: 'Copyright © 2023 长沙国贸集团有限公司 All Rights Reserved',
        custName1: '免责声明',
        custName2: '主办：中国（湖南）自由贸易试验区长沙片区管理委员会',
        custName3: '运营：长沙国贸集团有限公司',
        bei: '湘ICP备2023015428号-1',
    },
    offerings: {
        '01': '“优势”',
        title: '易货服务',
        title1: '助力中外',
        superiority: {
            title: '易货优势',
            tabsTitle1: '国内出口商',
            tabsTitle2: '国内进口商',
            tabsTitle3: '境外出口商',
            tabsTitle4: '境外进口商',
            desc: '解决产能过剩、出口收汇难及换汇合法性、长期持有贸易国本币贬值等问题，加快资金周转率，增加对外开拓外贸业务安全合法性。&享受专业的供应链金融、物流、商务等服务，规避汇率波动风险、降低各类手续费及采购成本。&通过中国提供的优质设备、技术等支持促进产业升级，提高产能及附加值，取得长效稳定的中国订单。&无需使用外汇，可以本币获得高附加值的中国优质商品，增加商业机会及市场竞争力。',
            desc1: '中国向贸易国输出先进技术、设备及基建工程、轻工业及日用品等，优化中国产能结构，带动贸易国产业升级、提升民生供给及生活水平、维持政局稳定，贸易国官方层面推广以矿产、农产等资源类产品与中国易货，实现中国与贸易国双方合作共赢。同时，通过商机发布全球化、业务管理智慧化、合规监管实时化、综合服务一体化的本易货贸易数字化管理服务平台，实现信息共享、协同监管，确保贸易真实性，保障各国贸易拓新发展，维护各国正常贸易秩序和外汇金融安全。',
        },
        procedure: {
            textList: '国内出口;国内进口;境外进口;境外出口;易货平台',
            desc: '国内出口商通过出海服务(例如基建)为非洲进口商提供服务，非洲进口商付款给非洲出口商，国内进口商采购非洲出口商的产品，最终将等价货值付给国内出口商&国内进口商从非洲出口商处获取需要的产品，原本要付给非洲出口商的资金，通过易货贸易平台中转，最终付款人民币给国内出口商即可&非洲出口商将出口货品依然卖给熟悉的中国进口商，原本从中国进口商收取的货值，通过易货贸易平台中转后，由非洲进口商支付&非洲进口商从中国出口商获取原支持的服务或商品，原本要付给中国出口商的资金，通过易货贸易平台中转，最终付款本币给非洲出口商即可',
            heed: '优势：出海的产品服务能获得比非官方渠道更高的汇率&优势：同样的资金能买到更多的非洲货品&优势：获得额外收益，带动产业发展，换取优质产品服务&优势：无需外汇仅需支付本币就能得到中国出口商的产品'
        },
        company: {
            title: '易货公司',
            value: '美兰集团（香港）有限公司',
            value1: '（科特迪瓦、安哥拉、坦桑尼亚）',
            value2: '南非TKL GROUP',
            value3: '（南非）',
            value4: '香港蓝洋投资有限公司',
            value5: '（马拉维）',
            value6: '长沙国贸集团有限公司',
            value7: '（中国）',
        },
        complement: {
            title: '配套服务',
            warehou: '仓储服务',
            logistics: '物流服务',
            clearSth: '通关服务',
            finance: '金融服务'
        },
        video: {
            title: '视频教程'
        },
        case: {
            title: '典型案例',
            download: '标准易货合同',
            project: '项目'
        },
        finance: {
            title: '金融服务',
            title1: '供应链金融服务 | 国贸集团',
            title2: '信用证服务 | 中行·工行·建行',
            title3: '信用保险服务 | 中国信保',
            text: '长沙国贸集团利用强大的资金优势，整合金融资源，可为境内厂家、终端消费者、贸易商等客户提供供应链金融解决方案。&供应链金融服务基于供应链上下游的真实贸易背景，以商业银行保理服务为法律依据，实现了供应链多级链属企业之间应收账款的债权融资，在盘活存量资产的同时，解决了链属小微企业融资难、融资贵的窘境。&完善的供应链金融服务平台不能只解决供应链上某一方的痛点，而是要综合银行、核心企业、链属企业等所有链上参与方的痛点及需求，建立起多方互惠共赢的优选解决方案，确保整条供应链皆可受益。&金融机构方面，通过长沙国贸集团供应链金融服务连接渠道方以及客户，可以有效利用其闲置授信额度。而整合的核心企业和各级供应商的信息流除了降低风险，更可以深度经营核心企业，联合营销其上下游，批量获客，以增强单一客户的盈利能力。',
            text1: '信用证是一种银行保证，承诺在符合特定条件下向受益人支付款项&信用证服务为中非易货贸易提供了安全和可靠的支付方式。在这种贸易模式下，买方和卖方之间存在一定的风险，如付款延迟、违约等。通过使用信用证，银行作为中间人扮演着支付和保证的角色，确保买方在交货满足特定条件后支付货款，同时保证卖方按照合同履行交货义务。这种机制减少了交易双方的不确定性，提供了更安全和可靠的支付环境；&通过信用证，买卖双方可以根据自身需求和贸易规模进行支付安排。信用证可以灵活地适应不同的交货和付款方式，如货到付款、预付款或分期付款等。这种灵活性有助于贸易伙伴在保持合作关系稳定的同时满足各自的资金需求;&银行作为可靠的金融机构，通过对信用证的认证和执行，为贸易伙伴提供了增加信任和信誉的机会。这种信任和信誉度有助于建立长期的合作关系，能吸引更多的潜在买家和卖家参与到中非易货贸易中，进一步推动贸易发展。',
            text2: '信用保险是一种由保险公司提供的贸易保障，旨在保护贸易参与者免受贸易风险的影响&信用保险服务为中非易货贸易提供了充分的保障。在国际贸易中，双方面临着一系列的风险，如买方违约、政治风险、货物损坏或灾害等。通过购买信用保险，贸易参与者可以获得保险公司的赔付保障，以减轻贸易风险带来的损失。这种保障有助于增强贸易伙伴之间的信任，促进双方之间的长期合作关系；&在易货贸易中，卖方通常面临付款延迟的风险，这可能导致资金流动问题。通过购买信用保险，卖方可以获得在买方违约时的赔付，确保及时收到应得的款项。这种流动性和灵活性有助于提高卖方的资金周转效率，并支持其持续发展和扩大贸易规模；&信保服务提供的保障可以降低交易风险，并提高交易伙伴之间的信任和信誉度。中信保还会对贸易伙伴的信用状况进行评估和监测，为市场参与者提供有关贸易伙伴的信用信息，进一步提高贸易的可预见性和稳定性。',
            text3: '合作金融机构'
        },
        logistics: {
            title: '物流服务',
            title1: '提供物流一站式服务',
            title2: '大型物流商广泛合作',
            title3: '海运运力的充分保障',
            text: '平台提供的物流一站式服务旨在满足现代商业环境下复杂而多样化的物流需求。通过集成物流信息系统、运输管理、仓储和分销网络等关键要素，对外提供全面的物流解决方案，从源头到终端实现无缝衔接的货物运输和管理；& 平台通过与各种运输公司建立合作伙伴关系，以确保货物在全球范围内的及时和安全运输。无论是陆路、海运还是空运，平台都能提供灵活的运输选择，根据客户需求提供最佳的运输方案，并确保货物按时到达目的地。',
            text1: '平台积极与多家大型物流央企展开广泛合作，以提供更强大、更全面的物流解决方案。其中，与中外运、中远海、中国物流、五矿物流等知名物流企业达成了合作意向，共同开展协作。&这些合作央企作为物流行业的领军者，拥有雄厚的实力和丰富的资源。通过与它们的合作，能让平台的客户充分利用其强大的运输网络和全球分布的港口、航线等优势。与中外运合作，可以拓展陆路运输网络，实现国内外货物的快速运输；与中远海合作，能够提供全球范围内的海运服务，覆盖主要港口和航线；与中国物流合作，能够利用其专业的仓储和分拨能力，实现高效的货物管理；与五矿物流合作，能够借助其丰富的矿产资源和物流经验，提供优质的供应链解决方案。',
            text2: '平台在海运领域积极寻求与国际船运巨头合作，以确保海运运力的充分保障。与MSC、COSCO、MAERSK、CMA等知名国际船运公司达成战略合作共识，特别在中非航线上提供充足的运力保障。&这些国际船运巨头在全球范围内拥有广泛的航线网络和雄厚的船队资源。与它们的合作能让平台的客户充分利用它们的船舶运力，确保货物在中非航线上的顺利运输。MSC、COSCO、MAERSK、CMA等公司的船队规模庞大且现代化，具备高效的运输能力和先进的船舶技术，能够满足不同规模和类型的货物运输需求，包括货物的装载、航线选择、船期安排等。客户也可以随时获得专业的海运咨询和支持，确保货物按时、安全地到达目的地。',
            title4: '合作物流商'
        },
        warehou: {
            title: '仓储服务',
            title1: '服务优势',
            title2: '精益仓储式服务',
            title3: '国内仓储多地服务',
            title4: '海外仓储加速布点',
            text: '平台依托其丰富的商务资源和物流能力，致力于提供精益仓储式服务，为客户提供完善的仓储解决方案。&平台通过深入了解客户的需求和业务模式，根据其特定的要求和市场情况，设计并优化仓储布局。基于对货物流转、存储和处理流程的深入分析，平台能够合理规划仓库的布局和容量，并优化货物的存储方式和管理流程，以提高仓储效率和减少成本。&平台依托自身强大的商务资源，与多个物流合作伙伴建立紧密的合作关系。通过与各地的仓库和物流设施进行战略性合作，平台能够在全球范围内提供完善的仓储网络，实现货物的快速存储、分拣和配送。这种合作模式不仅提高了平台的运作效率，还为客户提供了更广阔的仓储选择和更灵活的服务。',
            text1: '为了更好地满足客户的仓储需求，平台在中国境内的主要港口，如广州、青岛、大连、上海、深圳等地，设立了跨境易货仓库，提供国内仓储多地服务。&这些主要港口地理位置优越，与国内外的贸易中心和物流枢纽相连，具有重要的战略地位。平台在这些港口设立的跨境易货仓库，不仅能够迅速接收和分拨来自全球的货物，还能为国内客户提供便捷的仓储服务，满足其对快速、高效物流的需求。&通过在多地设立仓库，平台实现了仓储资源的分散和多样化。这使得客户可以根据业务需要和市场分布，在不同地区选择最适合的仓库位置，降低运输成本、缩短货物配送时间。无论客户需要存储、分拣、包装还是配送服务，平台都能够根据其需求，在多个港口提供灵活、可定制的仓储解决方案。',
            text2: '为了进一步提升海外仓储服务能力，平台已在非洲主要港口阿比让、吉布提、德班等地设立了跨境易货仓库，加速布点海外仓储网络。&非洲作为一个充满潜力和发展机遇的大陆，对于全球贸易和物流具有重要意义。平台在阿比让、吉布提、德班等非洲主要港口设立跨境易货仓库，旨在为客户提供高效、可靠的海外仓储服务，满足其在非洲市场的物流需求——通过在非洲主要港口设立仓库，平台能够快速响应客户的海外仓储需求，提供接收、分拨和配送等一系列仓储服务。这些仓库的选址考虑了港口交通便利性、地理位置优势以及与国内和国际供应链的衔接性，以最大程度地提高货物流通效率。&平台在这些非洲港口的仓库布局还考虑了当地的市场需求和特点。充分利用本土资源和合作伙伴的网络，平台能够为客户提供当地化的仓储解决方案，包括货物管理、分拣、包装等服务。同时，平台还注重仓库的安全性和保障措施，确保货物在存储和运输过程中的安全与完整。'
        },
        clearSth: {
            title: '通关服务',
            title1: '高效的通关一体化服务',
            title2: '涵盖国内外主要口岸',
            title3: '与国内外众多报关行合作',
            text: '平台提供高效的通关一体化服务，旨在帮助客户顺利完成跨境贸易，并提高通关效率。&平台与海关、报关行和相关监管机构建立了紧密合作关系，通过整合各方资源和信息，实现通关流程的优化和简化。平台的通关一体化服务涵盖了报关申报、文件处理、税费结算、监管合规等多个环节，为客户提供全方位的通关支持。&平台实现了电子化的通关流程。客户可以通过平台提供的在线平台或应用程序进行报关申报和信息提交，减少纸质文件的使用和繁琐的手续办理，大大提高了报关的速度和准确性。目前系统与海关和相关机构之间建立了实时数据共享和互联互通的机制。这使得平台能够在海关审批、税费结算等环节与相关机构进行快速、高效的信息交流和协同处理，缩短了通关时间，减少了不必要的延误和纠纷。同时我们还提供专业的通关咨询和法律法规解读。关务团队具备丰富的通关经验和深入的行业知识，能够帮助客户理解和遵守跨境贸易的相关规定，并为其提供合规的通关建议。',
            text1: '无论是国内口岸还是国际口岸，平台都与相关海关、报关行和监管机构建立了紧密的合作关系，以实现通关服务的一体化。&国内口岸方面，平台覆盖了包括广州、青岛、大连、上海、深圳、霍尔果斯等在内的多个重要口岸。这些口岸地理位置优越，与全国各地的生产基地和消费市场相连，是国内贸易的关键枢纽。&而在国际口岸方面，平台涵盖了诸如亚历山大、阿比让、吉布提、德班、新西罗斯克等全球重要港口。这些口岸作为国际贸易的重要节点，连接着各个国家和地区的供应链和物流网络。平台通过与当地海关和监管机构的合作，为客户提供进出口报关、税费结算、文件处理等全方位的通关服务。',
            text2: '平台与国内外众多报关行紧密合作，形成了一个强大的合作网络。这些报关行在通关领域拥有丰富的经验和专业知识，熟悉各地的海关政策和规定，能够为客户提供定制化的通关解决方案。&合作的报关行覆盖了国内外各个重要口岸和贸易热点地区，包括广州、青岛、大连、上海、深圳、长沙、武汉等国内口岸，以及诸如亚历山大、阿比让、吉布提、德班、圣彼得堡等国际口岸的知名报关行。这些合作伙伴与平台密切合作，共同协调和处理客户的通关事务，确保通关流程的顺利进行；&各大报关行的专业团队为客户提供专业的报关申报、文件处理、税费结算等服务，确保客户的货物能够顺利通过海关，并在规定的时间内完成通关手续。'
        },
        tobacco: {
            bigTitle: '（马拉维、坦桑尼亚农产品项目）',
            bigTitle1: '跨国别易货模式',
            title: '马拉维烟草项目',
            title1: '中湘拉维：中国化肥、烤烟机等与坦桑尼亚等国家腰果、白芝麻等农产品跨非洲国家易货',
            text1: '湖南中湘拉维国际贸易有限公司（简称“中湘拉维”）成立于2023年2月，注册资金500万元人民币，位于中国（湖南）自由贸易试验区长沙芙蓉片区隆平高科技园，主营货物进出口；机械设备销售；金属矿石销售；农副产品销售；食品销售；化肥销售等。&在当今中非经贸合作迅猛发展的大背景下，湖南与马拉维具有经济和资源互补性，合作潜力巨大，为积极推动中国与马拉维国际经贸的合作发展，助推湖南省开放型经济尤其是中非经贸实现高质量发展，中湘拉维的成立得到了湖南省委省政府众多部门的大力支持，公司按照省、市政府要求将打造湖南乃至中国与马拉维共和国的国际贸易供应链和外贸综合服务平台，旨在成为中国与马拉维共和国之间的国际贸易合作桥梁与窗口。',
            text2: '2023年3月9日至14日，马拉维共和国农业部长塞缪尔·达利索·卡瓦莱率团访问湖南，赴长沙、郴州、岳阳等地高校、高新技术企业、农业产业基地等参观考察。&在湘期间，在马拉维驻华使馆和湖南省外办的见证下，卡瓦莱代表马拉维政府与湖南中湘拉维国际贸易有限公司签署了烟草贸易协议，中湘拉维公司未来每年将从马拉维进口烟草1万吨，并计划于6月底与马方签署农产品贸易合作协议。湖南农业大学将与马拉维签署教育合作备忘录，加强在农作物培育、农资、人才培育领域的合作。郴州市将向马拉维捐赠一批小型农用机械，助力马拉维农业实现机械化现代化。岳阳观盛投资发展有限公司、郴州东江鱼集团、田野智能等一大批湖南企业表示将赴马拉维考察，积极拓展对马贸易。&据悉，湖南与马拉维具有经济和资源互补性，合作潜力巨大。即将落地的马拉维共和国驻长沙总领事馆既是马拉维在中国的第一家总领事馆，也是设在湖南的第一个非洲国家总领事馆，湖南将迎来和马拉维合作的黄金期。'
        },
        grapefruit: {
            bigTitle: '南非西柚项目',
            title: '南非西柚项目',
            titleEn: 'Case-Sharing: South Africa Grapefruit Project',
            title1: 'Takela Group：南非西柚与建材的易货贸易',
            text1: '2021年7月21日，首批5条来自南非共和国的红西柚货柜，抵达上海洋山港并完成清关，这标志着中国(湖南)自贸试验区易货贸易首单试单顺利完成，这也是中非贸易的创新之举。&首单易货贸易，由南非Takela 集团采购的红西柚等货物，交换湖南省对非易货贸易有限公司提供的建材、小商品等，双方签订了400万美元的易货贸易合同。“南非红西柚汁肉饱满，在市场上很受欢迎;南非takela 集团正在承接政府经济适用房，对建材有强烈需求。双方一拍即合。”湖南省对非易货贸易有限公司负责人陈细和说。作为等价交易，该公司5月17日和5月31日分别以易货贸易监管方式报关，出口建材小商品去南非德班港。&“对易货贸易，也有人不理解，说‘这都啥年代了还以物换物，这不是贸易方式的退步嘛’。其实这背后有现实考量。”陈细和介绍，目前非洲国家普遍外汇短缺，这在一定程度上限制了中非贸易往来。“考虑到非洲国家币种汇率不稳定，有可能造成资产贬值，外贸公司不敢轻易采用现汇贸易。”&湖南与非洲国家贸易交往源远流长，但开展境外易货贸易尚未有过先例。去年，湖南自贸试验区获批后，长沙片区雨花区块高桥大市场，成为中非经贸深度合作先行区改革创新试验田，承担建设易货贸易中心。&“在试单过程中，我们得到了海关、税务、外汇等部门的大力支持和共同协作。”自贸雨花管委会负责人肖向东介绍，目前，湖南自贸试验区正在加速组建中非易货贸易联盟，长沙自贸试验区雨花区块将搭建易货贸易数字化平台，扩大交易种类和贸易国家和地区，助力易货贸易实现从“一对一”变为“一对多”“多对多”。',
            text3: '南非西柚项目是中非经贸合作以来的首个项目，它通过农业产品与建材产品的易货贸易呈现，中国获得南非优质的有口皆碑的西柚，南非获得国内继续基建用的建材，其大致的易货流程如下——',
            text4: '1.撮合：易货平台找到中国的进出口商，南非的进出口商，确认撮合匹配成功后，四家进出口商经官网注册并提交企业资料通过平台的审核（此时如果已注册但暂未撮合成功，出口商可到平台发布资金需求，进口商可到平台发布采购需求，再由平台根据各类资金与采购信息详细沟通与实现撮合）；&2.签约：中国进出口商和国内的易货平台签订易货协议，南非的进出口商和南非的易货平台签订易货协议（南非的易货平台属于国内易货平台的子公司承建）；&3.对冲：平台确认双方的货值，在符合条件的情况下，国内贸易平台和境外贸易平台执行货值对冲；&4.通关：国内出口商通过国内易货平台，出口建材到境外易货平台，境外出口商通过境外易货平台，出口西柚到国内易货平台（顺序不分先后，一般是先有境外出口商出口产品到国内，因为国内的生产能力更足随时可以交付出口到南非，出口商一般会要求易货平台上门提货）；&5.结算：境内和境外的易货平台收到货物后，执行针对进口商和出口商的各类应收应付结算，发起对账与确认，开具相应的凭证和票据；&6.收款：此时货物需要交给进口商，需要先由进口商付款给易货平台，境内和境外的易货平台对进口商实现收款（收款包含服务费，顺序不分先后）；&7.交货：易货平台在收到进口商支付的等值货款后，将货发给进口商，一般为本地送货，境内易货平台交货给境内进口商，境外易货平台交货给境外进口商（顺序不分先后）；&8.付款：易货平台将进口商支付的货款，在扣除一系列服务费用后，支付给出口商，境内易货平台支付给境内出口商，境外易货平台支付给境外出口商（顺序不分先后）；',
            text5: '除西柚等农产品外，南非还有丰富的矿产资源，尤其是钻石举世闻名，而南非因为国内工业体系不完善，也需要中国的各类电器、箱包、日化等物美价廉的物品，后续国贸和南非TKL集团将继续采用类似模式，快速实现其他货品的易货贸易服务。'
        },
        rubber: {
            bigTitle: '（科特迪瓦腰果、橡胶项目）',
            bigTitle1: '标准易货模式',
            title: '科特迪瓦橡胶项目',
            title1: '美兰集团：中国厂房、机械设备等与科特迪瓦橡胶、腰果等农产品易货',
            text1: '科特迪瓦人口共2938万，全年GDP为726.9亿美元，国内生产总值增长率为6.5％，近年来的经济发展、政局稳定性保持在较好水平，可可生产和出口居世界第一位，占全球供给量的45％，对中国的机械、工程、工厂等设施设备需求较为旺盛。&橡胶版块是美兰集团目前在科特迪瓦的最大的农业支持项目，目前美兰集团在科特迪瓦已形成15万吨/年生产能力。经易货平台撮合，长沙国贸集团与美兰集团达成以中国生产的厂房、机械等设备，与科特迪瓦生产的腰果、橡胶等农产品进行新型易货贸易合作。',
            text2: '除橡胶产品外，美兰在深耕非洲的其他各类产品，例如棉花、棉纱、棕榈油、大豆、玉米、大米、木薯、淀粉、小麦、白糖等，都有望通过易货贸易，实现对厂房建设、机械设备出口的资金回笼，尤其是腰果和可可，有望在橡胶后，采用类似模式，快速实现易货贸易服务。'
        }
    },
    about: {
        title: '易货交易',
        title1: '联系我们',
        freeTrade: '关于长沙自贸区',
        internationalTrade: '关于易货平台',
        textInfo: '中国（湖南）自贸试验区长沙片区总面积79.98平方公里，主要有长沙经开区区块、临空区块、会展区块、雨花区块、芙蓉区块五大区块，涉及长沙县、雨花区、芙蓉区、三个行政区域，长沙经开区、临空产业集聚区、黄花综保区、会展新城、隆平高科技园五个园区。&战略定位：^对接“一带一路”建设，突出临空经济，重点发展高端装备制造、新一代信息技术、生物医药、电子商务、农业科技等产业，基本建成“一基地一中心一先行区一增长极”，即打造全球高端装备制造业基地、内陆地区高端现代服务业中心、中非经贸深度合作先行区和中部地区崛起增长极。&发展目标：^按照中国（湖南）自由贸易试验区总体方案要求，以制度创新为核心，以可复制可推广为基本要求，加强改革系统集成。全面落实中央关于加快建设制造业强国、实施中部崛起战略等要求，发挥东部沿海地区和中西部地区过渡带、长江经济带和沿海开放经济带结合部的区位优势，充分发挥开放、改革、创新的联动效应。经过三至五年的改革探索，率先形成国内一流营商环境体系，形成更多有国际竞争力的制度创新成果；引领建设世界级先进制造业集群，全面提升全球产业分工体系的参与度和影响力；全面拓展开放崛起新空间，深入探索中非经贸合作新路径新机制，为进一步扩大内陆地区对外开放积累实践经验，高标准高质量建设自贸试验区，在全国自贸试验区建设中走在前列。&重点任务：^构建一流国际化营商环境体系，贸易高质量发展促进体系，多元高效金融服务体系，综合性立体化现代物流体系。围绕三一集团、蓝思科技等重点企业，发展工程机械、智能终端、新能源材料等产业，打造全球高端装备制造业基地；突出临空经济，进一步发展航空服务、总部经济、科技服务、会展经济、国际医疗、文化教育等产业，建设内陆高端现代服务业中心；依托湖南高桥大市场建设中非经贸合作示范区。&产业布局：^长沙经开区区块重点发展高端装备制造、新一代信息技术、生物医药等产业，着力打造全球高端装备制造业基地。长沙临空经济示范区核心区区块重点发展生物医药、电子商务、航空物流与保税服务、临空高端商务服务等产业，着力打造高端临空产业集聚区。会展区块重点发展以会议会展产业为主导的现代服务业，打造国际中高端会议会展承办地和高端现代服务业集聚新区。雨花区块重点发展市场采购、驻地综合服务、商贸流通等产业，打造中非经贸深度合作先行区。',
        contactList: '联系我们&长沙片区：0731-85666683&长沙片区经开区块：0731-84020185&长沙片区临空区块：0731-84079186&长沙片区会展区块：0731-88969210&长沙片区雨花区块：0731-85881891&长沙片区芙蓉区块：0731-84680283',
        textInfo1: '2023年，是习近平总书记提出“一带一路”倡议、真实亲诚对非政策理念和正确义利观10周年。10年来，在中国和一带一路国家领导人战略引领下，围绕资源互补、相互开放等优势，国际贸易发展空间巨大，未来十分可期。相对来看，在国际贸易蓬勃发展的同时，仍然存在一些堵点和难点，一定程度上制约了贸易规模的进一步加速增长。例如，外汇储备不足、汇率波动大等带来的结算难题，中国境内外国家间供需信息、贸易商机不够实时化、透明化、智能化等难题。&基于上述背景，为进一步落实国际贸易发展理念，有效解决国际贸易发展难题，在湖南省、长沙市政府的坚强领导下，在湖南自由贸易试验区长沙片区管委会的精心指导下，由长沙国贸集团牵头搭建新型易货贸易交易平台，围绕“开放合作、开放创新、开放共享”理念，旨在为国际贸易提供更加灵活、智慧、安全、高效的一键式线上交易平台，实现货物跨国循环、资金各国境内独立循环的新型易货贸易。&目前，通过易货平台撮合，中国已与科特迪瓦、安哥拉、马拉维、南非等非洲国家达成易货贸易意向，总体运行情况良好。6月21日，长沙国贸集团与美兰集团（香港）公司正式签订新型易货贸易协议。在长沙国贸集团与美兰集团（香港）公司达成合作协议的基础上，首单中国机械设备与科特迪瓦腰果、橡胶易货业务已顺利启动，规模约2000万元人民币。',
        inter: {
            vision: '愿景',
            visionDesc: '让易货助力中非更上一层楼',
            mission: '使命',
            missionDesc: '成为服务各园区的优秀外贸综合服务平台',
            custDesc: '长沙国贸集团有限公司&是长沙市政府为全面落实“三高四新”战略定位和使命任务&深入实施强省会战略&充分发挥湖南自贸试验区长沙片区制度优势而组建的市级国有贸易平台企业&由长沙市国资委依法依规进行资产监管&委托湖南自贸试验区长沙片区负责业务管理，长沙城发集团负责具体经营。&公司注册成立于 2022 年 10 月，注册资本 30 亿元人民币&战略定位为具有较强政府政策引导职能、业务涵盖范围较广、服务客户较多的外贸综合服务平台&借助长沙市政府及湖南自贸区长沙片区的政策及资源优势&通过产贸融合发展、做大进出口贸易、创新体制机制&努力建设成为省市对非易的排头兵、外贸人才的培养中心、全国一流的贸易集团。',
            explain: '长沙国贸集团有限公司于2022年10月经长沙市委市政府批准成立，注册资本30亿元。其中，长沙城发集团占比49%，临空产投集团占比20%，长沙经开集团占比20%，雨花城投集团占比11%。公司战略定位为“长沙打造对外开放高地的引领者，强省会战略支撑平台”，以发展对非贸易和进出口外贸业务为主，力争到2026年进出口贸易额突破1000亿元。&近年来，在市委、市政府坚强领导下，在湘江新区、自贸区、高新区以及商务、海关、国资委等单位大力支持下，城发集团将国贸公司定位为“一核三极”业务布局中重要一极，推进国贸公司实现快速发展，累计实现营收304亿元，进出口贸易额216亿元，上缴税金25亿元，成为湖南省重点外贸供应链平台企业、十佳优秀外贸企业，在落实“三高四新”战略定位和使命任务以及强省会战略中积极发挥示范引领和辐射带动作用。&围绕“打造一流的省级外贸综合服务平台、对非贸易平台”战略定位，国贸公司坚持推行“1+N”发展模式，着力做实采购、物流、报关、分销等为主的外贸综合服务，积极探索实施保税维修、跨境电商等贸易新业态，大力拓展电子元器件、新能源材料等进口业务，支持高新技术产业发展。通过优质外贸服务，与30多个国家实现贸易往来，与俄罗斯、越南等“一带一路”国家建立稳定贸易关系，累计服务市场主体92家，辐射带动各类企业上万家，在橡胶、有色金属、生鲜冻品板块建立稳定渠道，橡胶业务市场占有率达25%、位居全国前三，对非贸易年增长超50%。'
        }
    },
    index: {
        '1': '长沙国贸集团有限公司',
        '2': '美兰集团（香港）有限公司',
        '3': '南非TKL GROUP',
        '4': '香港蓝洋投资有限公司',
        '5': '于2022年10月经长沙市委市政府批准成立，注册资本30亿元。其中，长沙城发集团占比49%，临空产投集团占比20%，长沙经开集团占比20%，雨花城投集团占比11%。公司战略定位为“长沙打造对外开放高地的引领者，强省会战略支撑平台”，以发展对非贸易和进出口外贸业务为主，力争到2026年进出口贸易额突破1000亿元。',
        '6': '美兰集团于2001年在香港成立，随着市场环境的变化，集团于2014年及2019年先后进行过两次重组，完成了企业的外部创新以及内部运营机制改革。目前，美兰集团成为一家全球性专业从事大宗农产品生产、加工、销售为一体的企业，主要经营的品种有橡胶、棉花、棉纱、棕榈油、大豆、玉米、大米、木薯、淀粉、小麦、白糖等农产品。',
        '7': '美兰集团在全球共有九个全资分子公司及两个合资公司，主要分布于中国香港、上海、青岛、湖南长沙、湖南岳阳、马来西亚、泰国、缅甸、越南、科特迪瓦。公司发展策略采取产、研、投相结合，生产加工及贸易一体化，在泰国、马来西亚、科特迪瓦都设有天然橡胶生产加工工厂，截至目前海外总投入固定资产约8500多万美金，注入流动资金约2亿美元。',
        '8': '成立于2010年，总公司位于南非约翰内斯堡，旗下拥有七家全资子公司，集团主要业务板块分为：',
        '9': '1.进出口贸易板块，年出口铬矿25-30万吨，锰矿60-70万吨，南非牛肉200-300柜，柑橘300-500柜，出口总额约为4.8-5.2亿美金每年。并且在铬矿，锰矿产品方面，TKL集团已入驻并投资了当地矿山源头，最大保障限度的保障了每月稳定出货量。',
        '10': '2.进口业务板块， 主要以铝合金，建材，板材房为主，支撑南非政府项目的配套的同时，布局南部非洲海外仓，响应一带一路，中非自贸的政策，',
        '11': '3.南非政府工程项目，如政府援助经济房，城市公共设施维护，机场，学校，医院等的招标建设。南非当地重大项目中都有TKL集团参与，比如Mthatha机场建设，南非政府安置房建设等。',
        '12': '为湖南中湘拉维国际贸易有限公司（成立于2023年，注册资金500万元）与马拉维共和国开展易货贸易专门收购的外商业务子公司。2023年3月马拉维共和国农业部长塞缪尔·达利索·卡瓦莱率团访问湖南，卡瓦莱部长代表马拉维政府与中湘拉维公司签署了烟草贸易协议，中湘拉维公司将助力马拉维烟草行业产业升级，输出中国优质的化肥、农机设备等，双方将共同拓展双边国际贸易。',
        '13': '取消',
    },
    inter: {
        title: '国贸集团',
        text: '长沙国贸集团有限公司成立于2022年10月20日，是长沙市委市政府批准成立、湖南自贸试验区长沙片区负责业务管理、长沙城市发展集团有限公司负责具体经营的市级国有公司。公司注册资本30亿元，战略定位为“长沙打造对外开放高地的引领者、强省会战略支撑平台”，力争2026年进出口贸易额突破1000亿元。&长沙国贸集团坚持以做大进出口贸易额作为核心发展目标，通过夯实供应链服务、拓展自营贸易、延伸仓储物流、深化对外投资，在推动外贸高质量发展上闯出新路子。着力发展四大业务板块：一是区域合作。在湖南自贸区各区块设立子公司，结合各园区特色产业，输出专业化外贸综合服务。二是产贸融合。结合本省、市重点生产型产业，设立产业供应链合资公司，延伸本地重点产业链条。三是专业拓展。挑选行业优势企业或项目经营团队，成立专业型供应链合资公司，提升专业供应链服务水平。四是境外投资。深度挖掘外贸资源，联合优质企业对外投资，运用基金、股权投资、并购等方式，挖掘、孵化和并购境外产业资源、成熟工厂，以资本为纽带引导产业聚集并向产业链上游延伸降低原材料成本，实现“走出去”战略。',
        text1: '2023年2月，在新春伊始之际，湖南自贸试验区长沙片区重点支持国有外贸平台，长沙国贸集团即迎来新年首批进口生鲜货品——15吨加拿大波士顿龙虾；该批龙虾在当地被捕捞上岸后，第一时间被处理打包直飞中国，抵达长沙黄花综保区经分拣、加工包装后，将陆续分拨销往北京、上海、广州、深圳等各大城市。&围绕“打造一流的省级外贸综合服务平台、对非贸易平台”战略定位，国贸公司坚持推行“1+N”发展模式，着力做实采购、物流、报关、分销等为主的外贸综合服务，积极探索实施保税维修、跨境电商等贸易新业态，大力拓展电子元器件、新能源材料等进口业务，支持高新技术产业发展。通过优质外贸服务，已与多个国家实现贸易往来，与俄罗斯、越南等“一带一路”国家建立稳定贸易关系，辐射带动各类企业上万家，在橡胶、有色金属、生鲜冻品板块建立了稳定渠道，并在对非贸易中保持每年增长。'
    },
    meilan: {
        title: '美兰集团',
        text: '美兰集团于2001年在香港成立，随着市场环境的变化，集团于2014年及2019年先后进行过两次重组，完成了企业的外部创新以及内部运营机制改革。目前，美兰集团成为一家全球性专业从事大宗农产品生产、加工、销售为一体的企业，主要经营的品种有橡胶、棉花、棉纱、棕榈油、大豆、玉米、大米、木薯、淀粉、小麦、白糖等农产品。&随着产业结构的不断升级，美兰集团正在积极地应对一次产业链的重构，调整产业结构，将劳动密集型生产线转移至东盟以及非洲地区，为非洲等地的产业转型升级赋能。&美兰集团的高层管理人员拥有丰富实操经验，具有丰富而深厚的专业知识，多年来一直致力于在农产品行业进行深入的探索和开拓。集团集合全方位的成熟供应链系统，依托长期的大宗商品进出口业务经验及强烈的行业敏感度，适应市场形势的变化，为建立起与国内市场相适应、与国际市场相对接的现代市场营销体系进行全球布局。&美兰集团在全球共有九个全资分子公司及两个合资公司，主要分布于中国香港、上海、青岛、湖南长沙、湖南岳阳、马来西亚、泰国、缅甸、越南、科特迪瓦。公司发展策略采取产、研、投相结合，生产加工及贸易一体化，在泰国、马来西亚、科特迪瓦都设有天然橡胶生产加工工厂，截至目前海外总投入固定资产约8500多万美金，注入流动资金约2亿美元。&美兰集团将把追求商业成功和履行社会责任有机地统一起来，也将在中非合作中越走越稳，行稳致远。',
        text1: '联系美兰集团&电话&邮箱&网址&地址：湖南省长沙市岳麓区洋湖街道先导路179号恒伟湘江时代A2栋502',
    },
    tkl: {
        title: '南非TKL集团',
        text: '南非TKL集团成立于2010年，总公司位于南非约翰内斯堡，旗下拥有七家全资子公司，集团主要业务板块分为：&1.进出口贸易板块，年出口铬矿25-30万吨，锰矿60-70万吨，南非牛肉200-300柜，柑橘300-500柜，出口总额约为4.8-5.2亿美金每年。并且在铬矿，锰矿产品方面，TKL集团已入驻并投资了当地矿山源头，最大保障限度的保障了每月稳定出货量。&2.进口业务板块， 主要以铝合金，建材，板材房为主，支撑南非政府项目的配套的同时，布局南部非洲海外仓，响应一带一路，中非自贸的政策，&3.南非政府工程项目，如政府援助经济房，城市公共设施维护，机场，学校，医院等的招标建设。南非当地重大项目中都有TKL集团参与，比如Mthatha机场建设，南非政府安置房建设等。&虽然还是一家年轻的公司，但Takela-Group Development and Construction (Pty) Ltd (Takela)自2014年成立以来，已经在服务、可靠性和卓越的建筑方面赢得了声誉。&Takela最初成立的目的是为了促进国家住房发展，我们的团队已经在南非各地完成了各种项目，获得了客户和行业伙伴的赞誉。&该公司在CIDB完全注册，并拥有1级BEE评级。自成立以来，我们还在NHBRC注册，Takela一直保持着良好的信誉。&虽然我们的总部位于约翰内斯堡米德兰，但在过去的两年里，我们主要在东开普省地区建立了坚实的基础。我们有一个位于东伦敦的办公室，以及在我们每个项目地点设立的各种现场办公室，甚至在该地区最偏远的地方。',
        text1: '目标和宗旨&作为一家南非的建筑公司，Takela努力为我们的客户提供准确、诚实和彻底的建筑服务，从项目的开始到完成。我们的专业知识和对每个建筑项目的承诺是我们成长的动力。&我们有动力去实现提供成功所需的元素，并在社区建造结构，为我们的客户，我们的社会和社区留下持久的印象。&联系信息&联系电话:&电子邮箱:'
    },
    lanyang: {
        title: '中非拉维-香港蓝洋投资',
        text: '湖南中湘拉维国际贸易有限公司（简称“中湘拉维”）成立于2023年2月，注册资金500万元人民币，位于中国（湖南）自由贸易试验区长沙芙蓉片区隆平高科技园，主营货物进出口；机械设备销售；金属矿石销售；农副产品销售；食品销售；化肥销售等。&在当今中非经贸合作迅猛发展的大背景下，湖南与马拉维具有经济和资源互补性，合作潜力巨大，为积极推动中国与马拉维国际经贸的合作发展，助推湖南省开放型经济尤其是中非经贸实现高质量发展，中湘拉维的成立得到了湖南省委省政府众多部门的大力支持，公司按照省、市政府要求将打造湖南乃至中国与马拉维共和国的国际贸易供应链和外贸综合服务平台，旨在成为中国与马拉维共和国之间的国际贸易合作桥梁与窗口。&香港蓝洋投资有限公司为湖南中湘拉维国际贸易有限公司（成立于2023年，注册资金500万元）与马拉维共和国开展易货贸易专门收购的外商业务子公司。2023年3月马拉维共和国农业部长塞缪尔·达利索·卡瓦莱率团访问湖南，卡瓦莱部长代表马拉维政府与中湘拉维公司签署了烟草贸易协议，中湘拉维公司将助力马拉维烟草行业产业升级，输出中国优质的化肥、农机设备等，双方将共同拓展双边国际贸易。',
        text1: '公司地址：湖南省长沙市芙蓉区人民东路676号万象时代广场1栋25楼&国际贸易业务&孙经理：&供应链国内外服务&郭经理：'
    }
}